/* eslint-disable */
// Setup elements that react to user scroll
import * as basicScroll from 'basicscroll';
import AOS from 'aos';

function init() {
  window.addEventListener('curtain', () => {
    const { headerType } = document.getElementsByTagName('body')[0].dataset;
    const windowHeight = window.innerHeight;
    const expandingImage = document.querySelector(
      `.header-section-${headerType} .js-expanding-image`,
    );
    const homeHeading = document.querySelector(`.header-section-${headerType} .js-home-heading`);

    if (expandingImage) {
      const instance = basicScroll.create({
        elem: expandingImage,
        from: '0',
        to: `${windowHeight}px`,
        props: {
          '--matrixY': {
            from: 0,
            to: -495,
          },
          '--matrixScale': {
            from: 1,
            to: 1.2482,
          },
        },
      });

      const instancePx = basicScroll.create({
        elem: expandingImage,
        from: '0',
        to: `${windowHeight}px`,
        props: {
          '--matrixYPx': {
            from: '0px',
            to: '-495px',
          },
        },

        outside: (instance, percentage, props) => {
          if (percentage < 110) {
            AOS.refresh();
          }
        },
      });

      instance.start();
      instancePx.start();
    }

    if (homeHeading) {
      const instance = basicScroll.create({
        elem: homeHeading,
        from: '0',
        to: `${windowHeight}px`,
        props: {
          '--headingTop': {
            from: '0vh',
            to: '-28vh',
          },
        },
      });

      instance.start();
    }

    const templateSliderTypeThree = document.querySelector(
      `.header-section-${headerType} .header-type-3-container`,
    );

    if (templateSliderTypeThree) {
      const instance = basicScroll.create({
        elem: document.querySelector('.js-colour-block'),
        from: '0',
        to: `${window.innerHeight * 0.4}px`,
        props: {
          '--scaleColourBlock': {
            from: '0.9',
            to: '1.3',
          },
        },

        inside: (instance, percentage, props) => {
          if (window.innerWidth > 1024) {
            document
              .querySelector(`.header-section-${headerType} .header-type-3-container`)
              .classList.remove('active');

            if (document.querySelector(`.header-section-${headerType} .header-type-3`).swiper) {
              document
                .querySelector(`.header-section-${headerType} .header-type-3`)
                .swiper.slideTo(0, 400, true);
            }
          }
        },
        outside: (instance, percentage, props) => {
          document
            .querySelector(`.header-section-${headerType} .header-type-3-container`)
            .classList.add('active');
        },
      });
      instance.start();

      const templateInstance = basicScroll.create({
        elem: document.querySelector('.js-colour-block'),
        from: '0',
        to: `${window.innerHeight * 0.2}px`,
        props: {
          '--templateMovement': {
            from: '14.5%',
            to: '0%',
          },
        },

        inside: (instance, percentage, props) => {
          if (window.innerWidth > 1024) {
            document
              .querySelectorAll(
                `.header-section-${headerType} .header-type-3-container .swiper-button-next img`,
              )
              .forEach(trigger => {
                trigger.classList.add('hide');
                trigger.classList.remove('show');
              });
          } else {
            document
              .querySelectorAll(
                `.header-section-${headerType} .header-type-3-container .swiper-button-next img`,
              )
              .forEach(trigger => {
                trigger.classList.remove('hide');
                trigger.classList.add('show');
              });
          }
        },
        outside: (instance, percentage, props) => {
          if (window.innerWidth > 1024) {
            document
              .querySelectorAll(
                `.header-section-${headerType} .header-type-3-container .swiper-button-next img`,
              )
              .forEach(trigger => {
                trigger.classList.remove('hide');
                trigger.classList.add('show');
              });
          } else {
            document
              .querySelectorAll(
                `.header-section-${headerType} .header-type-3-container .swiper-button-next img`,
              )
              .forEach(trigger => {
                trigger.classList.remove('hide');
                trigger.classList.add('show');
              });
          }
        },
      });

      templateInstance.start();
    }
  });
}

(() => {
  init();
})();
